export default __webpack_public_path__ + "static/placeholder-games-df134f502c5ed06b9fa3ae294d9643ac.png";